<div class="card3dsecure-header-wrapper">
    <div class="card3dsecure-header-content-wrapper">
        <a routerLink="/app/login" sessionReviveClick>
          <img class="logo" src="assets/logo_white.svg" />
        </a>
        <div style="width: 100%">&nbsp;</div>
        <mat-select
          class="language-selector"
          panelClass="language-selector-panel"
          [value]="selectedLang"
          (selectionChange)="selectionChange($event)"
          sessionReviveClick>
          <mat-select-trigger>
            <div class="language-selector-option-wrapper">
              <img class="flag" src="assets/flags/{{selectedLang.value}}.svg" />
              <div class="locale">{{selectedLang.title}}</div>
              <mat-icon class="icon-down"></mat-icon>
            </div>
          </mat-select-trigger>
          <mat-option *ngFor="let lang of langs" [value]="lang">
            <div class="language-selector-option-wrapper">
              <img class="flag" src="assets/flags/{{lang.value}}.svg" />
              <div class="locale">{{lang.title}}</div>
            </div>
          </mat-option>
        </mat-select>
    </div>
</div>
